import { createClient } from "tinacms/dist/client";
import { queries } from "./types";
export const client = createClient({ url: 'https://content.tinajs.io/1.4/content/4d440eb3-2c21-4393-86b4-98fe62ba3470/github/master', token: '5427e5e54c37a500d8d80e2074579534caebe3c7', queries,  });
export default client;
  